const permittedRedirectHosts = [
    "cloud.lms.com",
    "dev.cloud.lms.com",
    "sit.cloud.lms.com",
    "qa.cloud.lms.com",
    "lms.com",
]

export const validateUrl = (url) => {
    try {
        var parsedUrl = new URL(url);
        if (permittedRedirectHosts.find(item => item === parsedUrl.host.toLowerCase()))
            return url;
        else return null;
    }
    catch {
        return null;
    }
}